import { GetterTree } from 'vuex'
import { RootState } from '@/store/types';
import { RestrictionsState } from './types';

export const getters: GetterTree<RestrictionsState, RootState> = {
  restrictions: state => state.restrictions,
  restriction: state => state.restriction
}